import * as actionTypes from './actionTypes';

// Init state
export const state = {
  isLoading: true,
  isLoadingTable: false,
  updateList: false,
  isInitPage: false,
  initPageError: null,

  pagination: null,
  services: [],
  configuration: null,
};

export const reducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.LIST_SUCCESS:
    return {
      ...state,
      isInitPage: true,
      initPageError: null,
      isLoadingTable: false,
      updateList: false,
      pagination: payload.pagination,
      configuration: payload.configuration,
      services: payload.services,
    }
  case actionTypes.LIST_UPDATE:
    return {
      ...state,
      initPageError: null,
      isLoadingTable: true,
      updateList: true,
    }
  case actionTypes.LIST_ERROR:
    return {
      ...state,
      isInitPage: true,
      initPageError: {
        data: payload.data,
        status: payload.status,
        statusText: payload.statusText,
      },
      isLoadingTable: false,
    }
  case actionTypes.REMOVE:
    return {
      ...state,
      isLoadingTable: true,
    }
  case actionTypes.REMOVE_SUCCESS:
    return {
      ...state,
      isLoadingTable: false,
      updateList: true,
    }
  case actionTypes.REMOVE_ERROR:
    return {
      ...state,
      isLoadingTable: false,
    }
  default:
    throw new Error();
  }
};

// Action creator
export function listSuccess(payload) {
  return { type: actionTypes.LIST_SUCCESS, payload }
}
export function listError(data, status, statusText) {
  return { type: actionTypes.LIST_ERROR, payload: { data, status, statusText } }
}
export function removeService(id) {
  return { type: actionTypes.REMOVE, payload: { id } }
}

export function removeSuccess() {
  return { type: actionTypes.REMOVE_SUCCESS }
}

export function removeError() {
  return { type: actionTypes.REMOVE_ERROR }
}

export function listUpdate() {
  return { type: actionTypes.LIST_UPDATE }
}
